import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductCatalog from './marketplace/ProductCatalog';
import OwnershipTracking from './marketplace/OwnershipTracking';
import LicenseManagement from './marketplace/LicenseManagement';

const MarketplaceManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'products' | 'purchases' | 'licenses'>('products');
  const [showAddProductModal, setShowAddProductModal] = useState(false);

  return (
    <div className="space-y-6 pt-16 lg:pt-0 pb-16 sm:pb-0 overflow-x-hidden">
      {/* Header */}
      <div>
        <h2 className="text-4xl font-bold text-gradient-cyan mb-2">
          🛒 {t('marketplace.title')}
        </h2>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 border-b border-[#31383D] overflow-x-auto">
        <button
          onClick={() => setActiveTab('products')}
          className={`px-4 sm:px-6 py-3 font-semibold transition-colors text-sm sm:text-base whitespace-nowrap ${
            activeTab === 'products'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('marketplace.products')}
        </button>
        <button
          onClick={() => setActiveTab('purchases')}
          className={`px-4 sm:px-6 py-3 font-semibold transition-colors text-sm sm:text-base whitespace-nowrap ${
            activeTab === 'purchases'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('marketplace.purchases')}
        </button>
        <button
          onClick={() => setActiveTab('licenses')}
          className={`px-4 sm:px-6 py-3 font-semibold transition-colors text-sm sm:text-base whitespace-nowrap ${
            activeTab === 'licenses'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('marketplace.licenses')}
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'products' && <ProductCatalog showAddModal={showAddProductModal} setShowAddModal={setShowAddProductModal} />}
      {activeTab === 'purchases' && <OwnershipTracking />}
      {activeTab === 'licenses' && <LicenseManagement />}
    </div>
  );
};

export default MarketplaceManagement;
